import {API} from '../../Services';

async function ConfigData(){
    return API.post(`/client-configs/`,{"version": 1800127});
}

export {ConfigData};
